if (!customElements.get('text-slideshow-handler')) {
  class TextSlideshowHandler {
    constructor(el) {
      this.slideshow = el;
      this.track = el.querySelector('[data-slideshow-track]');
      this.slides = el.querySelectorAll('.text-slideshow-block__slide');
      this.speed = parseInt(el.dataset.speed) || 5000;
      this.currentIndex = 0;
      this.timer = null;

      if (this.slides.length < 2) return;
      this.init();
    }

    init() {
      this.start();
      this.slideshow.addEventListener('mouseenter', () => this.stop());
      this.slideshow.addEventListener('mouseleave', () => this.start());
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.cycle(), this.speed);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
    }

    cycle() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      const offset = this.currentIndex * -100;
      this.track.style.transform = `translateX(${offset}%)`;
      
      // Update ARIA for current slide
      this.slides.forEach((slide, index) => {
        slide.setAttribute('aria-hidden', index === this.currentIndex ? 'false' : 'true');
      });
    }
  }

  const initTextSlideshows = () => {
    document.querySelectorAll('[data-text-slideshow]').forEach(el => {
      if (!el.dataset.initialized) {
        new TextSlideshowHandler(el);
        el.dataset.initialized = 'true';
      }
    });
  };

  document.addEventListener('DOMContentLoaded', initTextSlideshows);
  
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initTextSlideshows);
    document.addEventListener('shopify:block:select', (e) => {
      // Re-init or handle editor changes if needed
      initTextSlideshows();
    });
  }
}